import { RepoFactory } from '@/baseRepository/Factory';
const merchantMessagesRepository = () => RepoFactory.get('merchantMessages');
export const merchantMessagesActions = {
  getMerchantMessages(context, merchantId) {
    return new Promise((resolve, reject) => {
      merchantMessagesRepository()
        .getMerchantMessages(merchantId, `${context.getters.merchantBaseUrl}`)
        .then((res) => {
          context.commit('setMerchantMessages', res.data);
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
